import React from 'react';
import Image from '@splunk/dashboard-visualizations/Image';

export default () => (
    <Image
        options={{
            src: 'https://splunkudftest.s3-us-west-1.amazonaws.com/buttercup.png',
        }}
    />
);
